import type { FC } from "react";
import type { ProductHistoricalInsights } from "../historical-insights.types";
import { formatCurrency, formatPercent } from "../insights-utils";

interface Props {
  summary: ProductHistoricalInsights["summary"];
  windowMonths: number;
}

export const InsightsSummarySection: FC<Props> = ({ summary, windowMonths }) => {
  if (summary.totalSubmissions === 0) {
    return (
      <div className="space-y-3">
        <h3 className="text-sm font-semibold">Summary ({windowMonths} months)</h3>
        <p className="text-xs text-muted-foreground">
          No submission history found for this product in the last {windowMonths} months.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Summary ({windowMonths} months)</h3>
      <div className="grid grid-cols-2 gap-3">
        <KpiCard label="Total Submissions" value={String(summary.totalSubmissions)} />
        <KpiCard label="Quote Rate" value={formatPercent(summary.quoteRate)} />
        <KpiCard label="Bind Rate" value={formatPercent(summary.bindRate)} />
        <KpiCard label="Avg Premium" value={formatCurrency(summary.avgPremium)} />
        <KpiCard label="Median Premium" value={formatCurrency(summary.medianPremium)} />
        {summary.premiumRange && (
          <KpiCard
            label="Premium Range"
            value={`${formatCurrency(summary.premiumRange.min)} – ${formatCurrency(summary.premiumRange.max)}`}
          />
        )}
      </div>
    </div>
  );
};

const KpiCard: FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="rounded-md border p-3">
    <div className="text-xs text-muted-foreground">{label}</div>
    <div className="text-lg font-semibold">{value}</div>
  </div>
);
